enum navBarTestIds {
	navigationBar = 'nav-bar',
	navMenuItemContainer = 'advisor-container',
	menuItems = 'nav-menu-title',
	subMenuItems = 'nav-submenu-item',
	navMenuItemLink = 'nav-menu-item-link',
	navMenuSubMenu = 'nav-menu-sub-menu',
	navMenuHomeLogoContainer = 'nav-menu-home-logo-container',
	navSubMenuUlContainer = 'nav-sub-menu-ul-container',
}

export default navBarTestIds;
